import { computed, Injectable } from '@angular/core';
import { ApiSimpleService } from '@core/api/api.simple.service';

@Injectable({
  providedIn: 'root',
})
export class LogSearchMetoderService extends ApiSimpleService<string> {
  constructor() {
    super('/api/logsearch/metodenavne');
    super.load();
  }

  getDropdownData = computed(() => {
    const data = this.data();
    const list: { label: string; value: string }[] = [];
    data.forEach((item) => {
      const value = item;
      let label = item;
      if (item.includes('.')) {
        const splitted = item.split('.');
        label = splitted[1] + ' - ' + splitted[0];
      }
      list.push({
        label,
        value,
      });
    });
    return list.sort((a, b) => a.label.localeCompare(b.label));
  });
}
